import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'controlDisabled',
  pure: false,
  standalone: false
})
export class ControlDisabledPipe implements PipeTransform, OnDestroy {
  private valueChangesSubscription: Subscription;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public ngOnDestroy(): void {
    this.valueChangesSubscription?.unsubscribe();
  }

  public transform(formGroup: UntypedFormGroup | UntypedFormArray, skipPristineCheck?: boolean): boolean {
    if (!this.valueChangesSubscription) {
      this.valueChangesSubscription = formGroup.valueChanges.subscribe(() => this.changeDetectorRef.markForCheck());
    }

    return (!skipPristineCheck && formGroup.pristine) || this.touchedAndInvalid(formGroup.controls);
  }

  private touchedAndInvalid(controls: Object): boolean {
    return (Object as any)
      .values(controls)
      .some(
        (control) =>
          (!control.controls && (control.touched || control.dirty) && control.invalid) ||
          (control.controls && this.touchedAndInvalid(control.controls))
      );
  }
}
